<template>
  <div class="learn">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <div class="banner">
      <div class="banner-wrap">
        <h2>学习中心</h2>
        <div class="banner-line"></div>
        <p>Learning Center</p>
      </div>
    </div>
    <!-- <div class="crumbs">
            <span>当前位置：</span>
            <span>首页</span>
            <span @click="toActivity">活动 ></span>
            <span>创业大赛 </span> 
        </div> -->

    <div class="head">
      <!-- 下拉框 -->
    </div>
    <ul>
      <li @click="toOther(1)">
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" src="../../static/learn/l_cp.png" />
          </div>
          <div class="text">
            <div class="text-b">创新就业创业测评</div>
            <div class="text-s">
              《创新·就业·创业测评》系统由我国著名教育及心理学研究专家率领博士团队研发完成,采用线上答题的方式完成职业性格特质、创新思维、就业倾向/创业倾向及能力和个人综合素质测评等一套完整的人才测评系统，测评系统采用国际国内专业权威的测评量表,具有较高的效度和信度,可以为就业创业培训、就业精准指导等服务提供较强的参考。
            </div>
          </div>
          <button class="detailBtn">立即前往</button>
        </div>
      </li>
      <li @click="toOther(2)">
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" src="../../static/learn/l_mk.png" />
          </div>
          <div class="text">
            <div class="text-b">课堂在线</div>
            <div class="text-s">
              资讯、课程、专家、论坛、求职通道5大模块，学员、教师、机构、市级、省级、超级管理员6大角色，实现人脸识别、实名认证、人离线断等各种防刷课功能，有效追踪学员数据并进行统计和分析。
            </div>
          </div>
          <button class="detailBtn">立即前往</button>
        </div>
      </li>
      <li @click="toOther(3)">
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" src="../../static/learn/l_sx.png" />
          </div>
          <div class="text">
            <div class="text-b">网络创业实训</div>
            <div class="text-s">
              《启创网创》分为模拟商城、供销系统
              在线学习平台、培训管理系统四大部分。教学平台实现碎片化学习,并模拟运营管理的电商平台。涵盖了网络创业所需要的各项知识、技能、素质、能力,最终对网店经营数据进行整理、形成完整的店铺数据分析,培养提升创业者的各项网络创业能力。
            </div>
          </div>
          <button class="detailBtn">立即前往</button>
        </div>
      </li>
      <li @click="toOther(4)">
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" src="../../static/learn/l_mnt.png" />
          </div>
          <div class="text">
            <div class="text-b">创业模拟实训（通用版）</div>
            <div class="text-s">
              创新创业实训平台从创业者自我认知、创业能力塑造、创业团队组建、激发创新思维、创业项目选择、企业创建、企业经营管理、创业计划指定涵盖了创业者创业所需要的各项知识、技能、素质、能力,最终对创业者达到培养提升创业者的各项创业能力。
            </div>
          </div>
          <button class="detailBtn">立即前往</button>
        </div>
      </li>
      <li @click="toOther(5)">
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" src="../../static/learn/l_mng.png" />
          </div>
          <div class="text">
            <div class="text-b">模拟实训系统（网络版）</div>
            <div class="text-s">
              创新创业实训平台从创业者自我认知、创业能力塑造、创业团队组建、激发创新思维、创业项目选择、企业创建、企业经营管理、创业计划指定涵盖了创业者创业所需要的各项知识、技能、素质、能力,最终对创业者达到培养提升创业者的各项创业能力。
            </div>
          </div>
          <button class="detailBtn">立即前往</button>
        </div>
      </li>
    </ul>
    <div style="width: 100%; height: 20px"></div>
  </div>
</template>
<script>
import navigation from "@/components/common/navigation";

export default {
  name: "learn",
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {
    toOther(s) {
      if (s === 1) {
        //测评
        window.open("https://ceping.jycyfww.com", "_blank");
      } else if (s === 2) {
        //慕课
        window.open("https://muke.jycyfww.com", "_blank");
      } else if (s === 3) {
        // 网创
        window.open("http://116.62.157.29:8077/", "_blank");
      } else if (s === 4) {
        // 模拟实训 通用版
        window.open("http://116.62.157.29:8088/busion/", "_blank");
      } else if (5) {
        // 模拟实训 个人版
        window.open("http://www.qcwlcloud.com:8900/busion/", "_blank");
      }
    },
  },
  created() {},
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>
<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.learn {
  width: 100%;
  background-color: #F5F5F5;
  .banner {
    width: 100%;
    height: 500px;
    background: url(../../static/learn/banner.png);
    background-size: 100% 100%;
    background-position: center;
    .banner-wrap {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      position: relative;
      h2 {
        font-size: 65px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        position: absolute;
        right: 100px;
        top: 100px;
        line-height: 60px;
      }
      .banner-line {
        width: 80px;
        height: 2px;
        background: #ffffff;
        position: absolute;
        top: 191px;
        right: 276px;
      }
      p {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
        position: absolute;
        top: 223px;
        right: 176px;
      }
    }
  }

  ul {
    width: 1200px;
    list-style-type: none;
    margin: 50px auto 100px;
    li {
        width: 1200px;
        padding: 20px;
        background-color: #FFFFFF;
        box-sizing: border-box;
        margin-bottom: 20px;
      .li-wrap {
        height: 230px;
        width: 100%;
        position: relative;
        img {
          height: 100%;
          width: 370px;
          float: left;
        }
        .text {
          width: 790px;
          float: right;
          padding: 10px 20px;
          box-sizing: border-box;
          .text-b {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 50px;
          }
          .text-s {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            text-align: justify;
          }
          .people {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            margin: 5px 0;
            span {
              color: #0f9bf1;
              font-size: 18px;
              margin-right: 64px;
            }
          }
          .date {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            span {
              color: #333333;
            }
          }
        }
        .detailBtn {
          width: 150px;
          height: 40px;
          border: 1px solid #5fc0e4;
          border-radius: 3px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5fc0e4;
          outline: none;
          position: absolute;
          right: 30px;
          bottom: 20px;
          background: #fff;
        }
        .detailBtn:hover {
          color: #fff;
          background: rgba(0, 0, 0, 1);
        }
      }
    }
    li:hover {
        .li-wrap {
            background-color: #FAFAFA;
            .text {
                .text-b {
                    color: #3476C1;
                }
            }
            .detailBtn {
                background-color: #5fc0e4;
                color: #fff;
            }
        }
    }
  }
}
</style>